import { render, staticRenderFns } from "./coldChain.vue?vue&type=template&id=13db07dc&scoped=true&"
import script from "./coldChain.vue?vue&type=script&lang=js&"
export * from "./coldChain.vue?vue&type=script&lang=js&"
import style0 from "./coldChain.vue?vue&type=style&index=0&id=13db07dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db07dc",
  null
  
)

export default component.exports